import FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import { FolderStore, getFolderTable } from 'owa-folders';
import { action } from 'satcheljs/lib/legacy';
import { createNewFolderService } from 'owa-folders';
import store from '../store/store';
import InboxRuleFolderType from '../store/schema/InboxRuleFolderType';

export interface NewFolderState {
    folderStore?: FolderStore;
}

let addNewFolderToStore = action('addNewFolderToStore')(function addNewFolderToStore(
    responseMessage: FolderInfoResponseMessage,
    parentFolderId: string,
    displayName: string
): Promise<string> {
    let folderResponse = responseMessage.Folders[0];

    // Get the parent folder tree type here. This will also become the treetype of the folder currently being added.
    const parentFolderTreeType = getFolderTable().get(parentFolderId).treeType;
    let folderToAddToStore: InboxRuleFolderType = {
        childFolderIds: [],
        displayName: displayName,
        folderId: folderResponse.FolderId.Id,
        folderType: folderResponse.__type,
        isHidden: false,
        parentFolderId: parentFolderId,
        parentFolderDisplayName: '' /* adding folder to root */,
        path: displayName /* can only create folders under the root */,
        treeType: parentFolderTreeType,
    };
    // add to end of array since new folders are added to the root
    store.contextMenuFolders.push(folderToAddToStore);
    return Promise.resolve(folderResponse.FolderId.Id);
});

export default function createNewFolder(
    displayName: string,
    parentFolderId: string
): Promise<string> {
    displayName = (displayName || '').trim(); // Do not allow whitespaces.

    return createNewFolderService(parentFolderId, displayName).then(
        (responseMessage: FolderInfoResponseMessage) => {
            if (responseMessage.ResponseClass == 'Success') {
                return addNewFolderToStore(responseMessage, parentFolderId, displayName);
            } else {
                throw new Error(responseMessage.MessageText);
            }
        }
    );
}
